





























































































































import {CatalogueItemModel, PriceListItemModel, PriceListModel, TenantModel} from '@/libs/Api';
import Page from '@/Page.vue';
import {Guid} from '@/libs/common/functions/guid';
import {Component, Ref, Watch} from 'vue-property-decorator';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {priceListsStore} from '@/libs/price-lists/+state/store';
import {catalogueItemsStore} from '@/libs/catalogue-items/+state/store';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {authStore} from "@/libs/auth/+store/store";
import {AuthGetter} from "@/libs/auth/models/auth-state";
import {tenantsStore} from "@/libs/tenants/+state/store";
import {CrudGetter} from "@/libs/core/+state/models/crud-getter";
import {cloneDeep} from "lodash";
import moment from 'moment';

@Component({})
export default class PriceListDialog extends Page {

    dialog = false;
    valid = true;
    saving = false;
    item: PriceListModel | null = null;
    priceSuffix = "";
    deleteDialog = false;
    deleting = false;
    collisionDialog = false;
    zeroOrGreaterRules = [
        (value: any) => {
          if (value !== 0) {
            return !!value || this.$t('validation.thisFieldIsRequired');
          }
          return true;
        },
        (value: any) => value >= 0 || 'Hodnota musí být větší nebo rovna 0',
    ];
    nameFilter: string | null = null;
    arePricesValid = true;

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    get priceListItems(): PriceListItemModel[] {
      if (this.nameFilter) {
        return this.item?.priceListItems?.where(x => (x.catalogueItem?.name ?? "").toString().toLowerCase().includes(this.nameFilter!.toLowerCase())).toArray() ?? [];
      }
      return this.item?.priceListItems?.toArray() ?? [];
    }
    
    get useLoweredPrice(): boolean {
        const tenantId = authStore.useGetter(AuthGetter.GetTenant);
        const tenant = tenantsStore.useGetter(CrudGetter.Detail, tenantId) as TenantModel;
        return tenant.useLoweredPrice == true;
    }

    @Ref() form!: any;
    
    open (id: string | null = null) {
        this.arePricesValid = true;
        this.nameFilter = null;
        this.dialog = true;
        this.item = null;
        this.valid = true;
        this.loadCatalogueItems().then((catalogueItems) => {
            priceListsStore.dispatch(CrudAction.Get, { id: id });
            this.subscribe(priceListsStore, CrudReponse.Get).then((e: PriceListModel) => {
                this.item = e;
                const notExistsingPriceListItems = catalogueItems.where(x => !this.item!.priceListItems!.any(n => n.catalogueItemId == x.id)).orderBy(x => x.name).select((x) => {
                    return {
                        id: Guid.EmptyGuid(),
                        catalogueItemId: x.id,
                        catalogueItem: x,
                        unitPrice: undefined
                    } as PriceListItemModel
                }).toArray();
                for (const x of notExistsingPriceListItems) {
                    this.item!.priceListItems!.push(x);
                }
                this.item.priceListItems = this.item.priceListItems?.orderBy(x => x.catalogueItem?.name).toArray();
            });
        });
    }

	openCloned (item: PriceListModel) {
        this.arePricesValid = true;
        this.nameFilter = null;
		const clonedItem = cloneDeep(item);
		clonedItem.id = Guid.EmptyGuid();
		clonedItem.priceListItems?.forEach(x => {
			x.id = Guid.EmptyGuid();
			x.priceListId = Guid.EmptyGuid();
		});
		this.item = clonedItem;
		this.dialog = true;
		this.valid = true;
		this.loadCatalogueItems().then((catalogueItems) => {
			const notExistsingPriceListItems = catalogueItems.where(x => !this.item!.priceListItems!.any(n => n.catalogueItemId == x.id)).orderBy(x => x.name).select((x) => {
				return {
					id: Guid.EmptyGuid(),
					catalogueItemId: x.id,
					catalogueItem: x,
					unitPrice: undefined
				} as PriceListItemModel
			}).toArray();
			for (const x of notExistsingPriceListItems) {
				this.item!.priceListItems!.push(x);
			}
			this.item!.priceListItems = this.item!.priceListItems?.orderBy(x => x.catalogueItem?.name).toArray();
		});
	}

    create (fromDate: string, toDate: string) {
        this.arePricesValid = true;
        this.nameFilter = null;
        this.dialog = true;
        this.item = null;
        this.valid = true;
        this.loadCatalogueItems().then((catalogueItems) => {
            this.item = {
                id: Guid.EmptyGuid(),
                fromDate: fromDate,
                toDate: toDate,
                priceListItems: catalogueItems.orderBy(x => x.name).select(x => {
                    return {
                        id: Guid.EmptyGuid(),
                        catalogueItemId: x.id,
                        catalogueItem: x,
                        unitPrice: undefined
                    } as PriceListItemModel
                }).toArray()
            } as PriceListModel;
        })
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.arePricesValid = this.item!.priceListItems!.all(x => x.unitPrice != null && Number(x.unitPrice) >= 0 && x.loweredUnitPrice != null && Number(x.loweredUnitPrice) >= 0);
            if (this.arePricesValid) {
                this.saving = true;
                this.item!.fromDate = moment(this.item!.fromDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
                this.item!.toDate = moment(this.item!.toDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss")
                priceListsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PriceListModel>(undefined, [
                    { field: "id", op: "ne", comparand: this.item!.id! },
                    { field: "fromDate", op: "lt", comparand: this.item!.toDate! },
                    { field: "toDate", op: "gt", comparand: this.item!.fromDate! },
                ], { pageIndex: 1, pageSize: 1 }, false, "PriceListDialogSaveCheck"));
                this.subscribe(priceListsStore, CrudReponse.GetAll, "PriceListDialogSaveCheck").then((e: PriceListModel[]) => {
                    if (e.length == 0) {
                        if (this.item!.id == Guid.EmptyGuid()) {
                            priceListsStore.dispatch(CrudAction.Create, { item: this.item });
                            this.subscribe(priceListsStore, CrudReponse.Create).then((e: PriceListModel) => {
                                this.saving = false;
                                this.close();
                            }).catch((e: any) => {
                                this.saving = false;
                            });
                        }
                        else {
                            priceListsStore.dispatch(CrudAction.Update, { item: this.item });
                            this.subscribe(priceListsStore, CrudReponse.Update).then((e: PriceListModel) => {
                                this.saving = false;
                                this.close();
                            }).catch((e: any) => {
                                this.saving = false;
                            });
                        }
                    }
                    else {
                        this.saving = false;
                        this.collisionDialog = true;
                    }
                }).catch((e) => {
                    console.error(e);
                    this.saving = false;
                })
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteItem () {
        this.deleting = true;
        priceListsStore.dispatch(CrudAction.Delete, { id: this.item?.id });
        this.subscribe(priceListsStore, CrudReponse.Delete).then((e: PriceListModel) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

    loadCatalogueItems (): Promise<CatalogueItemModel[]> {
        return new Promise<CatalogueItemModel[]>((resolve, reject) => {
            catalogueItemsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CatalogueItemModel>({ field: "name", index: 1, order: "asc"}));
            this.subscribe(catalogueItemsStore, CrudReponse.GetAll).then((e: CatalogueItemModel[]) => {
                resolve(e);
            }).catch((e) => {
                console.log(e);
                reject(e);
            })
        });
    }

}
